<template>
  <LoadingState v-if="status.isLoaded" :size="50" />
  <CloudServerHistoryTable v-else :events="events" :status="status" />
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import CloudServerHistoryTable from "@/components/smart/tables/CloudServerHistoryTable";
import LoadingState from "@/components/display/LoadingState";
import Status from "@/classes/Status";
import store from "@/store";

export default {
  name: "CloudServerHistory",
  components: {
    CloudServerHistoryTable,
    LoadingState,
  },
  props: {
    server: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const status = new Status(Status.LOADING);
    const events = computed(() => store.state.cloudServers.serverHistory);
    onMounted(() => {
      store
        .dispatch("cloudServers/getHistory", props.server.id)
        .then(() => (status.value = Status.LOADED));
    });
    return {
      events,
      status,
    };
  },
};
</script>
